<template>

  <body data-layout="horizontal" data-topbar="dark" v-if="showNav">
    <div id="layout-wrapper">
      <!-- Cabeçalho -->
      <header class="ishorizontal-topbar" style="background: linear-gradient(to right, black, black, #6366f1, #8b5cf6, #d946ef);">
    <div class="navbar-header d-flex justify-content-between align-items-center w-100">
        
        <!-- Logo -->
        <div class="navbar-brand-box">
            <a href="/" class="logo logo-light">
                <img :src="loginImage" alt="logo" height="60" class="auth-logo-dark me-start" name="login-img1">
            </a>
        </div>

        <!-- Botão para exibir menu no mobile -->
        <button class="navbar-toggler d-lg-none custom-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#topnav-menu-content" aria-controls="topnav-menu-content" aria-expanded="false" aria-label="Toggle navigation">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
        </button>

        <!-- Barra icons lado direito -->
        <div class="d-flex">
            <!-- Perfil -->
            <div class="dropdown d-inline-block" style="color: white;">
                <button type="button" class="btn header-item user text-start d-flex align-items-center" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="color: white;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="eva eva-person icon nav-icon rounded-circle header-profile-user">
                        <g data-name="Layer 2">
                            <g data-name="person">
                                <rect width="24" height="24" opacity="0"></rect>
                                <path d="M12 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4z"></path>
                                <path d="M18 21a1 1 0 0 0 1-1 7 7 0 0 0-14 0 1 1 0 0 0 1 1z"></path>
                            </g>
                        </g>
                    </svg>
                </button>
                <div class="dropdown-menu dropdown-menu-end pt-0">
                    <a class="dropdown-item" @click.prevent="goToProfile"><i class="mdi mdi-account-circle text-muted font-size-16 align-middle me-1"></i> <span class="align-middle" @click="goToProfile">Meu Perfil</span></a>
                    <a class="dropdown-item" href="https://api.whatsapp.com/send/?phone=351933017767&text&type=phone_number&app_absent=0" target="_blank"><i class="mdi mdi-lifebuoy text-muted font-size-16 align-middle me-1"></i> <span class="align-middle">Helpdesk</span></a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" @click.prevent="handleLogout">
                        <i class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>
                        <span class="align-middle">Logout</span>
                    </a>
                </div>
            </div>
            <!-- End Perfil -->
        </div>
        <!-- End Barra icons lado direito -->
    </div>

    <!-- Menu -->
    <div class="topnav">
        <div class="container-fluid">
            <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
                
                <!-- Adicionado colapso para mobile -->
                <div class="collapse navbar-collapse" id="topnav-menu-content">
                    <slot name="menu">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <router-link to="/dashboard" class="nav-link">
                                    <i class="eva eva-grid-outline"></i>
                                    <span>Dashboard</span>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/calendar" class="nav-link">
                                    <i class="eva eva-calendar-outline"></i>
                                    <span>Publicações</span>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/leads" class="nav-link">
                                    <i class="eva eva-person-done"></i>
                                    <span>CRM</span>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/IA" class="nav-link">
                                    <i class="eva eva-globe-outline"></i>
                                    <span>Meu Perfil & IA</span>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/chatia" class="nav-link">
                                    <i class="eva eva-message-square-outline"></i>
                                    <span>Chat IA</span>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/invoices" class="nav-link">
                                    <i class="eva eva-file-text-outline"></i>
                                    <span>Faturas</span>
                                </router-link>
                            </li>
                        </ul>
                    </slot>
                </div>

            </nav>
        </div>
    </div>
    <!-- Fim do Menu -->
</header>

      

      <!-- Conteúdo da Página -->
      <div class="main-content" style="min-height: 10vh;">
        <div class="page-content">
          <div class="container-fluid">
             <!-- Aqui Página -->
             <router-view></router-view>
            <!-- Fim Aqui Página -->
          </div>
        </div>
      </div>

      <!-- Rodapé -->
      <footer class="footer" style="display: block;">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12">
              All Rights Reserved and Developed by
              <a href="https://typingsolutions.pt/" target="_blank">Typing Solutions</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </body>

  <!-- Apenas exibe o conteúdo do router-view diretamente, sem cabeçalho/rodapé, nas rotas de login e OTP -->
  <router-view v-else>
  
  </router-view>

</template>

<script>
import { useRouter } from 'vue-router';

export default {
  name: 'App',
  props: {
    loginImage: {
      type: String,
      default: require('/src/assets/images/logo-white.png')
    }
  },
  methods: {
    goToProfile() {
    console.log("Profile")
    this.$router.push({ 
            name: 'Profile'
            
           }); 
  },
  },
  computed: {
    showNav() {
      // Verifica se a rota atual não é "/login" ou "/otp"
      return this.$route.path !== "/login" && this.$route.path !== "/otp" && this.$route.path !== "/";
    }
  },
  setup() {
    const router = useRouter();

    // Função de logout
    function handleLogout() {
      // Remove o token de autenticação do localStorage
      localStorage.removeItem('token');
      
      // Redireciona para a página de login
      router.push({ name: 'LoginView' });
    }

    return {
      handleLogout
    };
  }
  
};
</script>

<style>
.topnav .navbar-nav .nav-link .router-link  {
  font-size: 14.4px;
  position: relative;
  padding: 1rem 1.3rem;
  color: #7b8190;
  font-weight: 400;
}

.main-content {
  min-height: 10vh;
  background-color: var(--bs-body-bg);
}

.footer {
  display: block;
  bottom: 0;
  padding: 10px calc(1.5rem / 2);
  position: absolute;
  left: 0;
  color: #74788d;
  right: 255px;
  height: 60px;
  background-color: var(--bs-secondary-bg);
  box-shadow: 0 0px 4px rgba(15, 34, 58, 0.12);
  text-align: center;
}

</style>

<style>

    .custom-toggler {
        background: transparent !important; /* Sem fundo */
        border: none !important; /* Sem borda */
        padding: 8px; /* Ajustar tamanho */
        cursor: pointer; /* Indicar que é clicável */
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .custom-toggler svg {
        width: 30px;
        height: 30px;
        transition: transform 0.3s ease-in-out;
    }

    /* Efeito de hover */
    .custom-toggler:hover svg {
        transform: scale(1.1);
        stroke: #ffffff; /* Mantém o branco */
        opacity: 0.8; /* Efeito suave */
    }

    @media (min-width: 1200px) {
        body[data-layout=horizontal] .container-fluid, body[data-layout=horizontal] .navbar-header {
            max-width: 100%;
          }
      }

    
</style>
